var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let AbfragerCycleEndImageReward = class AbfragerCycleEndImageReward extends React.PureComponent {
    get app() {
        return this.props.question.context.app;
    }
    render() {
        const { question } = this.props;
        if (!question)
            return null;
        return (React.createElement("div", { style: { flex: '0 1 auto', paddingLeft: 15 } },
            React.createElement(AvailableTooltip, { placement: "bottom", title: "Zum Vergr\u00F6\u00DFern auf das Bild klicken" },
                React.createElement(Actor_, { actor: question.reward }))));
    }
};
AbfragerCycleEndImageReward = __decorate([
    observer
], AbfragerCycleEndImageReward);
export { AbfragerCycleEndImageReward };
